import React, { useState } from 'react';
import { Icon, Modal, Tooltip } from 'antd';
import ViewEmailModalDetails from './ViewEmailModalDetails';

type Props = {
  id: number,
};

export default function ViewEmailButton(props: Props) {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Tooltip title="View details">
        <Icon
          style={{ color: '#42A5F5', cursor: 'pointer' }}
          type="eye"
          onClick={() => setVisible(true)}
        />
      </Tooltip>
      <Modal
        title="Email Information"
        visible={visible}
        width={1000}
        onCancel={() => setVisible(false)}
      >
        <ViewEmailModalDetails id={props.id} />
      </Modal>
    </>
  );
}
